import { render, staticRenderFns } from "./table-search-bar.vue?vue&type=template&id=95700d10&scoped=true&"
import script from "./table-search-bar.vue?vue&type=script&lang=ts&"
export * from "./table-search-bar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95700d10",
  null
  
)

export default component.exports